import { mountStoreDevtool } from 'simple-zustand-devtools'
import { create } from 'zustand'
import { combine } from 'zustand/middleware'

export type FileStatus =
  | 'Adicionado'
  | 'Pendente'
  | 'Aprovado'
  | 'Reprovado'
  | 'Enviado'
  | 'Em aprovação'

export type DocumentState = {
  progress: number
  status: FileStatus
  file: File | null
  id_documento: number
  id_tipo_documento: number
  id_tipo_documento_vinculado: number
  nm_documento: string
  nm_tipo_documento: string
  st_tipo_pessoa: string
  sn_obrigatorio: string
  sn_envio_original: string
  observacao: string
}

type DocumentsInitialStateType = {
  documents: DocumentState[]
  selectedDocument: {
    document_id: number
    document_label: string
    document_name: string
  }
}

const DEFAULT_DOCUMENTS_INFO: DocumentsInitialStateType = {
  documents: [],
  selectedDocument: {
    document_id: 0,
    document_label: '',
    document_name: ''
  }
}
type DocumentUpdateStatus = {
  id: number
  newStatus: FileStatus
}

export type DocumentUpdateFile = {
  id: number
  newFile: File | null
}

export type DocumentUpdateProgress = {
  id: number
  newProgress: number
}
const useDocumentsStore = create(
  combine(DEFAULT_DOCUMENTS_INFO, (set) => ({
    setDocuments: (documents: DocumentState[]) => set({ documents }),
    setSelectedDocument: (selectedDocument: {
      document_id: number
      document_label: string
      document_name: string
    }) => set({ selectedDocument }),
    setDocumentStatus: ({ id, newStatus }: DocumentUpdateStatus) => {
      set((state) => {
        const updatedDocuments = state.documents.map((doc) =>
          doc.id_documento === id ? { ...doc, status: newStatus } : doc
        )
        return { documents: updatedDocuments }
      })
    },
    setDocumentFile: ({ id, newFile }: DocumentUpdateFile) => {
      set((state) => {
        const updatedDocuments = state.documents.map((doc) =>
          doc.id_documento === id ? { ...doc, file: newFile } : doc
        )
        return { documents: updatedDocuments }
      })
    },
    setDocumentProgress: ({ id, newProgress }: DocumentUpdateProgress) => {
      set((state) => {
        const updatedDocuments = state.documents.map((doc) =>
          doc.id_documento === id ? { ...doc, progress: newProgress } : doc
        )
        return { documents: updatedDocuments }
      })
    },

    resetDocumentsState: () => set(DEFAULT_DOCUMENTS_INFO)
  }))
)

if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Documents Store', useDocumentsStore)
}

export default useDocumentsStore
